/**
 * Focused views are opened from a list (a class, a person) and carry their own
 * back arrow, so the floating bottom pill and the feedback bubble are hidden
 * there to give the content the full height. The signed-in member's own profile
 * is not a focused view — it is a hub, so its chrome stays.
 */

/** True when the path is the signed-in member's own profile. */
export const isOwnProfilePath = (pathname: string, userId?: string | null): boolean =>
  !!userId && pathname === `/user/${userId}`;

/** True where the bottom pill and the feedback bubble should be hidden. */
export const isFocusedView = (pathname: string, userId?: string | null): boolean => {
  if (pathname.startsWith("/activity/")) return true;
  if (pathname.startsWith("/user/")) return !isOwnProfilePath(pathname, userId);
  return false;
};
